import React from "react";

const STATUS = {
  pending: { label: "In attesa", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  processing: { label: "In elaborazione", cls: "bg-blue-100 text-blue-800 border-blue-300" },
  shipment_created: { label: "Spedizione creata", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  waiting_tracking: { label: "Attesa tracking", cls: "bg-purple-100 text-purple-800 border-purple-300" },
  completed: { label: "Completato", cls: "bg-teal-100 text-teal-800 border-teal-300" },
  failed: { label: "Errore", cls: "bg-rose-100 text-rose-800 border-rose-300" },
  cancelled: { label: "Annullato", cls: "bg-slate-200 text-slate-700 border-slate-300" },
};

export function StatusBadge({ status, testid }) {
  const s = STATUS[status] || { label: status || "—", cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      {s.label}
    </span>
  );
}

export function StoreBadge({ code, testid }) {
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center rounded-md border border-slate-300 bg-slate-900 px-2 py-0.5 text-xs font-mono font-semibold text-white"
    >
      {code}
    </span>
  );
}
